import React, { useCallback, useEffect, useState } from "react";
import CondicionesFinancieras from "./CondicionesFinancieras";
import { pagosApi } from "./pagosApi";

const fechaHora = (valor) => String(valor || "").replace("T", " ").slice(0, 16) || "—";

export default function ConfiguracionMotor({ token, persistencia }) {
  const [versiones, setVersiones] = useState([]);
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const cargar = useCallback(async () => {
    if (!persistencia?.habilitada) return;
    setLoading(true); setError("");
    try { setVersiones(await pagosApi.snapshotsCondiciones(token) || []); }
    catch (requestError) { setError(requestError?.message || "No se pudo leer la configuración del motor."); }
    finally { setLoading(false); }
  }, [persistencia?.habilitada, token]);

  useEffect(() => { cargar(); }, [cargar]);

  const guardar = async () => {
    if (!archivo) return;
    setLoading(true); setError(""); setMensaje("");
    try {
      const respuesta = await pagosApi.cargarSnapshotCondiciones(archivo, token);
      setArchivo(null);
      setVersiones(await pagosApi.snapshotsCondiciones(token) || []);
      setMensaje(respuesta?.creado
        ? "Configuración guardada. Desde ahora será la base automática de las nuevas liquidaciones."
        : "Ese archivo ya estaba guardado; la configuración vigente no cambió.");
    } catch (requestError) { setError(requestError?.message || "No se pudo guardar la configuración."); }
    finally { setLoading(false); }
  };

  if (!persistencia?.habilitada) return <section className="pagos-panel"><h2>Configuración del motor</h2><div className="pagos-alert pagos-alert--warning">La persistencia de Pagos no está disponible.</div></section>;
  const actual = versiones[0];

  return <section className="pagos-panel" data-testid="configuracion-motor">
    <div className="pagos-section-heading"><div><h2>Configuración del motor de pagos</h2>
      <p>Esta es la base estable del cálculo. Se carga una vez y el sistema usa automáticamente la última versión guardada.</p></div>
      <span className={`pagos-status ${actual ? "pagos-status--safe" : "pagos-status--danger"}`}>{actual ? "Configurado" : "Falta configurar"}</span>
    </div>
    {error && <div className="pagos-alert pagos-alert--error" role="alert">{error}</div>}
    {mensaje && <div className="pagos-alert pagos-alert--info" role="status">{mensaje}</div>}

    <div className="pagos-settings-current">
      <div><span>Configuración vigente</span><strong>{actual?.archivo || "Todavía no hay una configuración guardada"}</strong>
        {actual && <small>Guardada por {actual.cargadoPor} el {fechaHora(actual.cargadoEn)}</small>}</div>
      {actual && <div className="pagos-settings-counts"><span>{actual.filasCuotas} planes de cuotas</span><span>{actual.condicionesPorCuit} condiciones por comercio</span><span>{actual.bonificaciones} bonificaciones</span></div>}
    </div>

    <div className="pagos-settings-editor">
      <div><h3>{actual ? "Actualizar configuración base" : "Cargar configuración inicial"}</h3>
        <p>Seleccioná el Excel del Conversor que contiene la hoja <strong>Listas</strong>. La versión anterior se conserva para auditoría.</p></div>
      <label><span>Archivo Excel</span><input aria-label="Libro con configuración financiera" type="file" accept=".xlsx,.xlsm" onChange={(event) => { setArchivo(event.target.files?.[0] || null); setMensaje(""); }} /></label>
      <button type="button" className="pagos-primary" disabled={!archivo || loading} onClick={guardar}>{loading ? "Guardando…" : actual ? "Guardar nueva versión" : "Guardar configuración inicial"}</button>
    </div>

    <details className="pagos-advanced-detail">
      <summary>Ver versiones anteriores ({Math.max(0, versiones.length - 1)})</summary>
      {!versiones.slice(1).length ? <p className="pagos-empty-inline">No hay versiones anteriores.</p> : <ul>{versiones.slice(1).map((item) => <li key={item.id}><strong>{item.archivo}</strong> · {fechaHora(item.cargadoEn)} · {String(item.sha256 || "").slice(0, 12)}…</li>)}</ul>}
    </details>

    <details className="pagos-advanced-detail">
      <summary>Editar reglas financieras adicionales</summary>
      <p>Usá esta sección sólo para reglas permanentes o excepciones aprobadas. Las tasas que cambian cada día se cargan dentro de la liquidación diaria.</p>
      <CondicionesFinancieras token={token} />
    </details>
  </section>;
}
